import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { clientHistoryComponent } from '../../common/clientHistory';
import { ClientModel } from '../../../model/index';
import { ClientService } from '../../../services/index';

import { AddEditClientComponent } from './addEditClient.component';
import { clientDocumentComponent } from '../../common/clientDocument.component';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'client-tab',
    templateUrl: './client.component.html',
})
export class ClientMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public clientdata: any[] = [];

    isLoadMask: Promise<any>;
    clientDataList:any;
    clientData: ClientModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    subscribeAuth;
    usertype = '';

    constructor(public store: Store<fromRootStore.State>, private clientService: ClientService, private modalService: BsModalService, public toasterService: ToasterService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'client_no',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    ngOnInit(): void {
        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.usertype = auth['usertype'];
                if (this.usertype == 'Super_Admin' || this.usertype == 'Admin') {
                    this.columns = [
                        { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
                        { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120 },
                        { name: 'Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
                        { name: 'Address', prop: 'address', width: 245, minWidth: 245, maxWidth: 245 },
                        { name: 'Mobile', prop: 'disp_mobile', width: 120, minWidth: 120, maxWidth: 120 },
                        { name: 'Reference', prop: 'reference_name', width: 150, minWidth: 150, maxWidth: 150 },
                        { name: 'Reg. Branch', prop: 'branch_name', width: 120, minWidth: 120, maxWidth: 120 },
                        { name: 'Action', prop: 'sno', width: 300, minWidth: 300, maxWidth: 300, sortable: false, cellTemplate: this.editDeleteTemplate }
                    ];
                } else {
                    this.columns = [
                        { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
                        { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120 },
                        { name: 'Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
                        { name: 'Mobile', prop: 'disp_mobile', width: 120, minWidth: 120, maxWidth: 120 },
                        { name: 'Reference', prop: 'reference_name', width: 150, minWidth: 150, maxWidth: 150 },
                        { name: 'Reg. Branch', prop: 'branch_name', width: 120, minWidth: 120, maxWidth: 120 },
                        { name: 'Action', prop: 'sno', width: 300, minWidth: 300, maxWidth: 300, sortable: false, cellTemplate: this.editDeleteTemplate }
                    ];
                }
                
					
            }
        });
        //         this.columns = [
        //             { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
        //             { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120 },
        //             { name: 'Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
        //             { name: 'Address', prop: 'address', width: 245, minWidth: 245, maxWidth: 245 },
        // /*             { name: 'Area', prop: 'area', width: 130, minWidth: 130, maxWidth: 130 },
        //  */         { name: 'Mobile', prop: 'disp_mobile', width: 120, minWidth: 120, maxWidth: 120 },
        //             { name: 'Reference', prop: 'reference_name', width: 150, minWidth: 150, maxWidth: 150 },
        //             { name: 'Reg. Branch', prop: 'branch_name', width: 120, minWidth: 120, maxWidth: 120 },
        //             { name: 'Action', prop: 'sno', width: 300, minWidth: 300, maxWidth: 300, sortable: false, cellTemplate: this.editDeleteTemplate }
        //         ];
        //debugger;
        //this.columns.splice([0]);

        this.pageCallback({ offset: 0 });

    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
       
        this.page.offset = pageInfo.offset;
        if (!this.suppressPaging){
            this.getClientList();
        }
        
    }

    /**
   * Called whenever the user changes the sort order
   */
/*     sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getClientList();
    } */
/*     onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    } */
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);

    }
    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.page.offset = 0;
        this.filterPanel.close();
        this.getClientList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getClientList();
    }
    getClientList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            title: this.title,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.clientService
            .getClientList(params)
            .then(function (res: any) {
                if (res.success) {
                    that.loadingIndicator = false;
                    that.page.count = res.totCnt;
                    that.clientDataList = res.data;
                } else {
                    let toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    /* bsModalRef: BsModalRef;
     public addBrandmodel(): void {
         this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
             keyboard: false,
             ignoreBackdropClick: true
         });

         this.bsModalRef.content.title = 'Add BRAND MODEL Details';
         this.bsModalRef.content.mode = 'Add';
         this.bsModalRef.content.brandmodeldata = {};
     }*/
    bsModalRef: BsModalRef;
    onAddEditClient(mode: string, row: any): void {
        let that = this,
            clientPhoto = [];
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);
        if (mode == "Add") {
            row = {
                'ref_id': ''
            }
        } else if (mode == 'Edit') {
            if (row['dob'] != '0000-00-00') {
                row['dob'] = new Date(row['dob']);
            }
            if (row['client_photo'] != '') {
                clientPhoto.push('assets/client/' + row['client_photo']);
            }
        }
        row['mode'] = mode;
        this.bsModalRef = this.modalService.show(AddEditClientComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-80'
        });
        this.bsModalRef.content.title = mode + ' Client Details';
        //this.bsModalRef.content.mode = mode;
        this.bsModalRef.content.clientdata = Object.assign({}, row);
        this.bsModalRef.content.clientPhoto = clientPhoto;
        this.bsModalRef.content.clientUpdateEvent.subscribe(($e) => {
            that.getClientList();
        });
    }
    // onEditClient(row: any): void {
    //
    //     this.bsModalRef = this.modalService.show(AddEditClientComponent, {
    //         keyboard: false,
    //         ignoreBackdropClick: true
    //     });
    //     this.bsModalRef.content.clientdata = Object.assign({}, row);
    //     this.bsModalRef.content.title = 'Edit CLIENT  Details';
    //     this.bsModalRef.content.mode = 'Edit';
    //     this.bsModalRef.content.clientdata = row;
    //
    // }


    /* onEditBrandmodel(mode: string, row: any): void {
         //this.filterPanel.close();
         let that = this;
         if (mode == "Edit") {
             row = {
                 'brand_id': ''
             }
         }
         this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
             keyboard: false,
             ignoreBackdropClick: true
         });
         this.bsModalRef.content.title = mode + 'EDIT BRAND MODEL Details';
         this.bsModalRef.content.mode = mode;
         this.bsModalRef.content.brandmodeldata = Object.assign({}, row);
         this.bsModalRef.content.brandUpdateEvent.subscribe(($e) => {
             that.getBrandmodelList();
         });
     }*/

    onDeleteClient(row: any): void {
        let that = this,
            msgTitle = 'Error',
            msgType = 'error',
            data = {
                client_id: row.client_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Client No: ' + row.client_no + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.clientService
                .deleteClient(row.client_id)
                .then(function (res: any) {
                    if (res.success) {
                        that.getClientList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        });
    }

    viewHistory(row) {
        let data = {
            client_id: row.client_id,
            from_page: 'followUp'
        }
        /*         that=this;
                that.commonService
                    .getClientHistory(data)
                    .then(function (res: any) {
                        that.clientdata=res.data;
                    }); */
        this.bsModalRef = this.modalService.show(clientHistoryComponent, {
            keyboard: false,
            //ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-50'
        });
        this.bsModalRef.content.showClientHistory = data;
    }
       /*  onChangePage(event) {
        let limit = this.page.limit - 1,
            pageNo = event.page,
            start = limit * (pageNo - 1),
            end = limit * (pageNo);
        let data = this.clientDataList.slice(start, end);
        this.clientData = data;
/*        this.footerRow(this.columns, false); // TO CHECK FOOTER
        document.getElementsByClassName('datatable-body')[0].scrollTop = 0; // TO KEEP SCROLL BACK TO TOP
        if (data.length < 13) {
            $('.grid-foot-total-row').ready(function () {
                $('.grid-foot-total-row').addClass('ext-bottom');
            });
        } */

        open(row) {
            let data = {
                client_id: row.client_id,
            }
            this.bsModalRef = this.modalService.show(clientDocumentComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-50'
            });
            this.bsModalRef.content.getPopUp = data;
          }
    
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/client/client.component.ts